import { createContext, useEffect, useRef, useState } from 'react';
import secureLocalStorage from 'react-secure-storage';
import axios from 'axios';

const MyContext = createContext();

const MyProvider = ({ children }) => {

    const BaseUrl = process.env.REACT_APP_API_URL || "http://localhost:3002";

    const [toastmsg, setToastMsg] = useState('');
    const [istoast, setIsToast] = useState(false);
    const [isLoginAuth, setIsLoginAuth] = useState(true);
    const [showModel, setShowModel] = useState('');
    const [profileShow, setProfileShow] = useState('');
    const [catActivePackage, setCatActivePackage] = useState('');
    const [aiActivePackage, setAiActivePackage] = useState('');
    const [nextCatPlanList, setNextCatPlanList] = useState([]);
    const [nextAiPlanList, setNextAiPlanList] = useState([]);
    const [catPackageList, setCatPackageList] = useState([]);
    const [aiPackageList, setAiPackageList] = useState([]);
    const [paymentStatus, setPaymentStatus] = useState('');
    const [paymentLoading, setPaymentLoading] = useState(false);
    const [selectPack, setSelectPack] = useState('');
    const [planType, setPlanType] = useState("");
    const [webLogo, setWebLogo] = useState("");
    const [supportChatStatus, setSupportChatStatus] = useState(0);
    const [otpAutofill, setOtpAutofill] = useState(1);
    const [googleLoginStatus, setGoogleLoginStatus] = useState(1);
    const [paymentToggle, setPaymentToggle] = useState(0);
    const [offlinePayUrl, setOfflinePayUrl] = useState("");
    const [supportEmail, setSupportEmail] = useState("support@astrosphere.api");
    const [supportEmailResponse, setSupportEmailResponse] = useState("Response within 24 hours");
    const [liveChatDays, setLiveChatDays] = useState("Available Mon–Sat");
    const [liveChatHours, setLiveChatHours] = useState("9:00 AM – 6:00 PM IST");
    const [businessHoursDays, setBusinessHoursDays] = useState("Mon – Sat");
    const [businessHoursTime, setBusinessHoursTime] = useState("9:00 AM – 6:00 PM IST");
    const [instagramUrl, setInstagramUrl] = useState("#");
    const [twitterUrl, setTwitterUrl] = useState("#");
    const [linkedinUrl, setLinkedinUrl] = useState("#");
    const [facebookUrl, setFacebookUrl] = useState("#");
    const [youtubeUrl, setYoutubeUrl] = useState("#");
    const [dynamicPages, setDynamicPages] = useState([]);
    const [signupBonusStatus, setSignupBonusStatus] = useState(0);
    const [signupBonusTokens, setSignupBonusTokens] = useState(0);
    const [signupBonusValidity, setSignupBonusValidity] = useState(0);
    const [signupAiBonusStatus, setSignupAiBonusStatus] = useState(0);
    const [signupAiBonusTokens, setSignupAiBonusTokens] = useState(0);
    const [signupAiBonusValidity, setSignupAiBonusValidity] = useState(0);

    const GetPackageRef = useRef(false);

    useEffect(() => {
        const IsAuth = secureLocalStorage.getItem("IsAuth");
        setIsLoginAuth(IsAuth == null ? true : false);
        handleGetActivePackage();

        // Fetch web logo and general settings globally
        axios.get(`${BaseUrl}/coustomer/services/list`)
            .then((res) => {
                setWebLogo(res.data.logo);
                setSupportChatStatus(res.data.support_chat_status || 0);
                setOtpAutofill(res.data.otp_autofill !== undefined ? res.data.otp_autofill : 1);
                setGoogleLoginStatus(res.data.google_login_status !== undefined ? res.data.google_login_status : 1);
                setPaymentToggle(res.data.paymenttoggle !== undefined ? res.data.paymenttoggle : 0);
                setOfflinePayUrl(res.data.offlinepay_url || "");
                setSupportEmail(res.data.support_email || "support@astrosphere.api");
                setSupportEmailResponse(res.data.support_email_response || "Response within 24 hours");
                setLiveChatDays(res.data.live_chat_days || "Available Mon–Sat");
                setLiveChatHours(res.data.live_chat_hours || "9:00 AM – 6:00 PM IST");
                setBusinessHoursDays(res.data.business_hours_days || "Mon – Sat");
                setBusinessHoursTime(res.data.business_hours_time || "9:00 AM – 6:00 PM IST");
                setInstagramUrl(res.data.instagram_url || "#");
                setTwitterUrl(res.data.twitter_url || "#");
                setLinkedinUrl(res.data.linkedin_url || "#");
                setFacebookUrl(res.data.facebook_url || "#");
                setYoutubeUrl(res.data.youtube_url || "#");
                setCatPackageList(res.data.Packages || []);
                secureLocalStorage.setItem("currency", res.data.currency);
                setSignupBonusStatus(res.data.signup_bonus_status || 0);
                setSignupBonusTokens(res.data.signup_bonus_tokens || 0);
                setSignupBonusValidity(res.data.signup_bonus_validity || 0);
                setSignupAiBonusStatus(res.data.signup_ai_bonus_status || 0);
                setSignupAiBonusTokens(res.data.signup_ai_bonus_tokens || 0);
                setSignupAiBonusValidity(res.data.signup_ai_bonus_validity || 0);
            })
            .catch((error) => {
                console.error("Failed to load logo dynamically:", error);
            });

        axios.get(`${BaseUrl}/coustomer/services/Ai_ChatPlan_list`)
            .then((res) => {
                setAiPackageList(res.data.Packages_AI || []);
            })
            .catch((error) => {
                console.error("Failed to load AI plans dynamically:", error);
            });

        axios.get(`${BaseUrl}/pages`)
            .then((res) => {
                if (res.data.status === 'success') {
                    setDynamicPages(res.data.data);
                }
            })
            .catch((error) => {
                console.error("Failed to load dynamic pages:", error);
            });

        // Premium Live Polling: Sync active package state in the background every 15 seconds
        const interval = setInterval(() => {
            const currentAuth = secureLocalStorage.getItem("IsAuth");
            if (currentAuth !== null) {
                // Bypass throttling ref to trigger background refresh
                GetPackageRef.current = false;
                handleGetActivePackage();
            }
        }, 15000);

        return () => clearInterval(interval);
    }, []);

    const handleGetActivePackage = () => {
        if (GetPackageRef.current) return;
        GetPackageRef.current = true;
        const Localdata = secureLocalStorage.getItem("Localdata");
        if (Localdata) {
            const JsconData = JSON.parse(Localdata);
            const p1 = axios.post(`${BaseUrl}/coustomer/services/get_package`, { user_id: JsconData.id })
                .then((res) => {
                    const PackageList = res.data.Purchas;
                    const GetAvtivePackage = PackageList.find((item) => item.active === 1);
                    const getNextPlanList = PackageList.filter((item) => item.active === 0);
                    setCatActivePackage(GetAvtivePackage);
                    setNextCatPlanList(getNextPlanList);
                })
                .catch((error) => {
                    console.error(error);
                });

            const p2 = axios.post(`${BaseUrl}/coustomer/services/get_ai_package`, { user_id: JsconData.id })
                .then((res) => {
                    const PackageList = res.data.Purchas;
                    const GetAvtivePackage = PackageList.find((item) => item.active === 1);
                    const getNextPlanList = PackageList.filter((item) => item.active === 0);
                    setAiActivePackage(GetAvtivePackage);
                    setNextAiPlanList(getNextPlanList);
                })
                .catch((error) => {
                    console.error(error);
                });

            Promise.all([p1, p2]).finally(() => {
                GetPackageRef.current = false;
            });
        } else {
            GetPackageRef.current = false;
        }
    }

    const value = {
        toastmsg, setToastMsg,
        istoast, setIsToast,
        isLoginAuth, setIsLoginAuth,
        showModel, setShowModel,
        profileShow, setProfileShow,
        catActivePackage, setCatActivePackage,
        aiActivePackage, setAiActivePackage,
        catPackageList, setCatPackageList,
        aiPackageList, setAiPackageList,
        nextAiPlanList, setNextAiPlanList,
        paymentStatus, setPaymentStatus,
        paymentLoading, setPaymentLoading,
        selectPack, setSelectPack,
        planType, setPlanType,
        BaseUrl, handleGetActivePackage,
        webLogo, setWebLogo,
        nextCatPlanList, GetPackageRef,
        supportChatStatus, setSupportChatStatus,
        otpAutofill, setOtpAutofill,
        googleLoginStatus, setGoogleLoginStatus,
        paymentToggle, setPaymentToggle,
        offlinePayUrl, setOfflinePayUrl,
        supportEmail, supportEmailResponse,
        liveChatDays, liveChatHours,
        businessHoursDays, businessHoursTime,
        instagramUrl, setInstagramUrl,
        twitterUrl, setTwitterUrl,
        linkedinUrl, setLinkedinUrl,
        facebookUrl, setFacebookUrl,
        youtubeUrl, setYoutubeUrl,
        dynamicPages, setDynamicPages,
        signupBonusStatus, signupBonusTokens, signupBonusValidity,
        signupAiBonusStatus, signupAiBonusTokens, signupAiBonusValidity,
    }

    return (
        <MyContext.Provider value={value}>
            {children}
        </MyContext.Provider>
    )

}

export { MyContext, MyProvider }